
//查询指定元件的关联元件(元件查询流股,流股查询元件)
export const queryRelateElement = (selectedElementData:any,dataSource:any) => 
{
    let fromNodes = [];
    let toNodes = [];
    let allNodes = [];
    let inLinks = [];
    let outLinks = [];
    let allLinks = [];

    if(selectedElementData.elementType==="node")
    {
        //查询关联流股
        let selectedElementKey = selectedElementData.elementID;
        let linkDatas = dataSource.linkDataArray;

        for(let i=0;i<linkDatas.length;i++)
        {
            let linkData = linkDatas[i];

            let link = 
            {
                key:linkData.key,
                name:linkData.linkName,
                data:linkData
            };

            if(linkData.to===selectedElementKey)
            {
                inLinks.push(link);
            }
            if(linkData.from===selectedElementKey)
            {
                outLinks.push(link);
            }
            if(linkData.to===selectedElementKey || linkData.from===selectedElementKey)
            {
                allLinks.push(link);
            }
        }
    }
    else if(selectedElementData.elementType==="link")
    {
        //查询关联元件
        let selectedElementKey = selectedElementData.elementID;
        let selectedLinkData = dataSource.linkDataArray.find(item=>item.key===selectedElementKey);
        let nodeDatas = dataSource.nodeDataArray;

        if(selectedLinkData)
        {
            for(let i=0;i<nodeDatas.length;i++)
            {
                let nodeData = nodeDatas[i];

                let node = 
                {
                    key:nodeData.key,
                    name:nodeData.nodeName,
                    data:nodeData
                };
                if(selectedLinkData.from===nodeData.key)
                {
                    fromNodes.push(node);
                }
                if(selectedLinkData.to===nodeData.key)
                {
                    toNodes.push(node);
                }
                if(selectedLinkData.from===nodeData.key || selectedLinkData.to===nodeData.key)
                {
                    allNodes.push(node);
                }
            }
        }
    }
    else if(selectedElementData.elementType==="group")
    {

    }

    let relateElements = 
    {
        fromNodes:fromNodes,
        toNodes:toNodes,
        allNodes:allNodes,
        inLinks:inLinks,
        outLinks:outLinks,
        allLinks:allLinks,
    };

    return relateElements;
};
